import React from "react";
import Select, { components, IndicatorProps, Props as ReactSelectProps, OptionTypeBase, ValueType } from "react-select";
import arrowUpIcon from "../../../../assets/images/arrow_up.svg";
import arrowBottomIcon from "../../../../assets/images/arrow_bottom.svg";

export interface SelectOptionType extends OptionTypeBase {
  value: string;
  label: string;
}

interface SelectOptions {
  onChange?: (option: SelectOptionType) => void;
}

interface SelectProps extends ReactSelectProps {
  selectOptions?: SelectOptions;
}

const CustomSelect: React.FC<SelectProps> = ({ selectOptions, ...props }) => {
  // custom OnChange (multi select won't work)
  // https://github.com/JedWatson/react-select/issues/3900
  // https://github.com/JedWatson/react-select/issues/2902
  const handleChange = (possibleValue: ValueType<SelectOptionType, false>): void => {
    if (!possibleValue || !selectOptions?.onChange) return;
    selectOptions.onChange(possibleValue as SelectOptionType);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const DropdownIndicator = (props: IndicatorProps<any, boolean>): React.ReactElement => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={props.selectProps.menuIsOpen ? arrowUpIcon : arrowBottomIcon} />
      </components.DropdownIndicator>
    );
  };

  return (
    <Select
      {...props}
      classNamePrefix="select"
      components={{ DropdownIndicator }}
      isSearchable={false}
      onChange={handleChange}
    />
  );
};

export default CustomSelect;
